import { useContext } from 'react';
import { assessmentsHooks } from '..';
import { AssessmentsContext, batteryStatusOptions } from '../AssessmentsContext';

const useBatteryHeaderItems = () => {
    const { batteryDefs } = useContext(AssessmentsContext)

    let headerItems = assessmentsHooks.useHeaderItems()

    let customHeaderItems = [
        headerItems.year,
        {
            ...headerItems.semester,
            name: "semester_of_execution",
            placeholder: "סמסטר ביצוע",
            disabled: false
        },
        {
            ...headerItems.grade_of_execution,
            name: "grade_of_execution",
            placeholder: "שכבת ביצוע"
        },
        {
            name: "battery_name",
            placeholder: "שם הסוללה",
            disabled: false,
            component: "autoComplete",
            options: batteryDefs,
            labelKey: "label"
        },
        {
            name: "profile",
            placeholder: "דירוג",
            component: "autoComplete",
            multiple: true,
            options: [{ id: 1, name: "1" }, { id: 2, name: "2" }, { id: 3, name: "3" }, { id: 4, name: "4" }, { id: 5, name: "5" }],
        },
        {
            name: "battery_status",
            options: batteryStatusOptions,
            placeholder: "סטטוס",
            component: "autoComplete",
            // multiple: true
        }
    ]

    return customHeaderItems
}

export default useBatteryHeaderItems